import InfoBox from "../../../../src/components/infoBox";
import DisclaimerBox from "../../../../src/components/DisclaimerBox";
import Disclosure from "../../../../src/components/Disclosure";
import * as React from 'react';
export default {
  InfoBox,
  DisclaimerBox,
  Disclosure,
  React
};